import { cn } from "../lib/cn.ts";

/** A Phosphor glyph (raw SVG from icons.ts), sized by the parent's CSS. */
export function Icon({ svg, class: className }: { svg: string; class?: string }) {
  return <span class={cn("icon", className)} aria-hidden="true" dangerouslySetInnerHTML={{ __html: svg }} />;
}
